export default __webpack_public_path__ + "static/media/bridged.6340dccd.svg";